import { createContext, useContext } from "react";

export const HospitalContext = createContext();

export const useHospitalContext = ()=> {
  return useContext(HospitalContext);
}
